export default "__VITE_ASSET__DIg24DTt__"